export default __webpack_public_path__ + "static/media/no-portrait.00f67d13.svg";